import { render, staticRenderFns } from "./PreviousRouter.vue?vue&type=template&id=67cc0312&scoped=true"
import script from "./PreviousRouter.vue?vue&type=script&lang=js"
export * from "./PreviousRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc0312",
  null
  
)

export default component.exports